'use strict';
jQuery($ => {

    class lastChancePopup {
        constructor() {
            this.inactiveSeconds = 20 * 1000;

            this.popup = $('.gecko-last-chance-popup');
            this.overlay = this.popup.find('.gecko-last-chance-popup__overlay');
            this.closeButton = this.popup.find('.gecko-last-chance-popup__close-button');

            this.activated = false;
            this.ignored = false;
            this.ignoredStorageKey = 'last-chance-popup-ignored';
            this.watch();

            if (localStorage.getItem(this.ignoredStorageKey) === "yes") {
                this.ignored = true;
            }

            this.overlay.on('click', (e) => {
                e.preventDefault();
                this.hide();
            });
            this.closeButton.on('click', (e) => {
                e.preventDefault();
                this.hide();
            });
        }

        watch() {
            // console.log('LastChance: Watching for mouse activity');
            this.mouseTimer = setTimeout(() => {
                this.show();
            }, this.inactiveSeconds);

            // Wait 5 seconds before watching for leave from top
            setTimeout(() => {
                // console.log('LastChance: watch for leave from top');
                $(document).on('mouseleave', (e) => {
                    if (!this.activated && e.clientY < 0) {
                        this.show();
                    }
                });
            }, 5000);

            // Cancel timeout when mouse moves, restart new timeout
            $(document).on('mousemove', (e) => {
                if (!this.activated) {
                    clearTimeout(this.mouseTimer);
                    this.mouseTimer = setTimeout(() => {
                        this.show();
                    }, this.inactiveSeconds);
                }
            });
        }

        show() {
            if (!this.ignored) {
                // console.log('LastChance: show popup');
                this.activated = true;
                this.popup.attr('data-status', 'active');
            } else {
                // console.log('LastChance: ignored, do not show');
            }
        }

        hide() {
            // console.log('LastChance: hide popup');
            this.popup.removeAttr('data-status');

            localStorage.setItem(this.ignoredStorageKey, 'yes');
        }
    }

    $(document).ready(() => {
        const popup = new lastChancePopup();
    });
});
